import { data } from '../../svg/FileShared/data';
import { makeIcon } from '../makeIcon';

export const FileShared = makeIcon(data, 'file_shared', 'FileShared');

export default FileShared;
